export default '1.0.6';